import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Edit } from "react-feather";

export const tableColumn = [
    {
        Header: "S. No",
        Cell: ({ row }) => row.index + 1,
        disableSortBy: true,
    },
    {
        Header: "Name",
        accessor: "enrolment.name",
    },
    {
        Header: "FIN",
        accessor: "enrolment.fin",
    },
    {
        Header: "TPMR Remarks",
        accessor: "student.student_tpmr.remarks"
    },
    {
        Header: "Actions",
        accessor: (data) => {
            return (
                <>
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Update Tpmr</Tooltip>}
                    >
                        <span>
                            <a
                                href={`/tms/batches/students-tpmr/${data?.enrolment?.id}/update-tpmr?batchId=${data?.batch_id}`}
                                target="_blank"
                                rel="noreferrer"
                                className="me-1"
                            >
                                <Edit />
                            </a>
                        </span>
                    </OverlayTrigger>
                </>
            );
        },
    },
];
